import {useContext, useEffect, useState } from "react"
import { PlaylistUse, UserContext } from '../../Routes/Routes1'
import {SongList } from '../../Components/components'
import './play-list.css'
import { useNavigate } from "react-router-dom"






function PlayList() {
    const [songsData,setSongsData]=useState([])
    const [isLoading,setLoading]=useState(false)
    const {playlistUpdate}=useContext(PlaylistUse)
    const {state}=useContext(UserContext)
    const navigate=useNavigate()

    if(!state){
        navigate('/login')
    }
    useEffect(()=>{
        
        if(state){
            const dataPromise=new Promise((res,rej)=>{
                const USER_DATA=JSON.parse(localStorage.getItem("sangeetUser"))
                setSongsData(USER_DATA)
            })
            dataPromise.then(setLoading(true))
        }
        
    },[playlistUpdate,state])
    
    return (
        <center>
           {
                isLoading && state?
                songsData.playList.length!==0?
                <div className='row mtmd'>
                    <div className='col-12'>
                        <SongList path='/playlist' songsData={songsData.playList}/>
                    </div>
               </div>:
               <div style={{marginTop:'20vh'}}>Playlist is empty</div>:
               <div style={{marginTop:'20vh'}}>Loading...</div>
           }
       </center>
    )
}

export default PlayList



